import {Component, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'exg-textarea',
  templateUrl: './exg-textarea.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: ExgTextareaComponent, multi: true
  }]
})
export class ExgTextareaComponent implements ControlValueAccessor {

  @Input() caption!: string;
  @Input() disabled!: string;
  @Input() required = false;
  @Input() pattern = '';
  @Input() minlength = 0;
  @Input() maxlength = 2048;
  @Input() hintText = '';

  _value: any = null;
  get value(): any {
    return this._value;
  }

  set value(obj: any) {
    this._value = obj;
    this.onChange(obj);
    this.onTouched(obj);
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor() {
  }

  // ControlValueAccessor -> OUT
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ControlValueAccessor <- IN
  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this._value = obj;
  }

  // ---------------

}
